import { StatsSkeleton, ChartSkeleton } from "./index";

export function AdminDashboardSkeleton() {
  return (
    <div className="space-y-8">
      {/* Stats Cards - 8 cards */}
      <StatsSkeleton count={8} />

      {/* Charts Section */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="border border-border rounded-lg p-6 bg-scandi-surface">
          <div className="mb-4">
            <div className="h-6 w-48 bg-muted animate-pulse rounded mb-2" />
            <div className="h-4 w-64 bg-muted animate-pulse rounded" />
          </div>
          <ChartSkeleton height={300} type="line" />
        </div>
        <div className="border border-border rounded-lg p-6 bg-scandi-surface">
          <div className="mb-4">
            <div className="h-6 w-48 bg-muted animate-pulse rounded mb-2" />
            <div className="h-4 w-64 bg-muted animate-pulse rounded" />
          </div>
          <ChartSkeleton height={300} type="pie" />
        </div>
      </div>

      {/* Top Vehicles and Hosts Section */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {/* Top Vehicles */}
        <div className="border border-border rounded-lg p-6 bg-scandi-surface">
          <div className="h-6 w-40 bg-muted animate-pulse rounded mb-4" />
          <div className="space-y-3">
            {Array.from({ length: 5 }).map((_, i) => (
              <div
                key={`vehicle-${i}`}
                className="flex items-center justify-between p-3 border border-border rounded"
              >
                <div className="flex-1 space-y-2">
                  <div className="h-4 w-32 bg-muted animate-pulse rounded" />
                  <div className="h-3 w-24 bg-muted animate-pulse rounded" />
                </div>
                <div className="h-4 w-20 bg-muted animate-pulse rounded" />
              </div>
            ))}
          </div>
        </div>

        {/* Top Hosts */}
        <div className="border border-border rounded-lg p-6 bg-scandi-surface">
          <div className="h-6 w-40 bg-muted animate-pulse rounded mb-4" />
          <div className="space-y-3">
            {Array.from({ length: 5 }).map((_, i) => (
              <div
                key={`host-${i}`}
                className="flex items-center justify-between p-3 border border-border rounded"
              >
                <div className="flex-1 space-y-2">
                  <div className="h-4 w-32 bg-muted animate-pulse rounded" />
                  <div className="h-3 w-24 bg-muted animate-pulse rounded" />
                </div>
                <div className="h-4 w-20 bg-muted animate-pulse rounded" />
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Recent Payments */}
      <div className="border border-border rounded-lg p-6 bg-scandi-surface">
        <div className="h-6 w-48 bg-muted animate-pulse rounded mb-4" />
        <div className="space-y-2">
          {Array.from({ length: 5 }).map((_, i) => (
            <div
              key={`payment-${i}`}
              className="flex items-center justify-between p-3 border border-border rounded"
            >
              <div className="flex-1 space-y-2">
                <div className="h-4 w-40 bg-muted animate-pulse rounded" />
                <div className="h-3 w-32 bg-muted animate-pulse rounded" />
              </div>
              <div className="h-4 w-24 bg-muted animate-pulse rounded" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
